__turbopack_context__.v({
  "cardWrapper": "CreditsDisplay-module__fwgGJW__cardWrapper",
  "codeLink": "CreditsDisplay-module__fwgGJW__codeLink",
  "columnHeaders": "CreditsDisplay-module__fwgGJW__columnHeaders",
  "creditAmount": "CreditsDisplay-module__fwgGJW__creditAmount",
  "creditCount": "CreditsDisplay-module__fwgGJW__creditCount",
  "creditDetails": "CreditsDisplay-module__fwgGJW__creditDetails",
  "creditIcon": "CreditsDisplay-module__fwgGJW__creditIcon",
  "creditInfo": "CreditsDisplay-module__fwgGJW__creditInfo",
  "creditItem": "CreditsDisplay-module__fwgGJW__creditItem",
  "creditItemAmount": "CreditsDisplay-module__fwgGJW__creditItemAmount",
  "creditItemExpiry": "CreditsDisplay-module__fwgGJW__creditItemExpiry",
  "creditLabel": "CreditsDisplay-module__fwgGJW__creditLabel",
  "creditSummary": "CreditsDisplay-module__fwgGJW__creditSummary",
  "creditSummaryHeader": "CreditsDisplay-module__fwgGJW__creditSummaryHeader",
  "creditSummaryIcon": "CreditsDisplay-module__fwgGJW__creditSummaryIcon",
  "creditsList": "CreditsDisplay-module__fwgGJW__creditsList",
  "divider": "CreditsDisplay-module__fwgGJW__divider",
  "emptyState": "CreditsDisplay-module__fwgGJW__emptyState",
  "header": "CreditsDisplay-module__fwgGJW__header",
  "heading": "CreditsDisplay-module__fwgGJW__heading",
  "intro": "CreditsDisplay-module__fwgGJW__intro",
  "introText": "CreditsDisplay-module__fwgGJW__introText",
  "mergeError": "CreditsDisplay-module__fwgGJW__mergeError",
  "mergedBadge": "CreditsDisplay-module__fwgGJW__mergedBadge",
  "mergedCode": "CreditsDisplay-module__fwgGJW__mergedCode",
  "mergedCodeBox": "CreditsDisplay-module__fwgGJW__mergedCodeBox",
  "mergedCodeContent": "CreditsDisplay-module__fwgGJW__mergedCodeContent",
  "mergedCodeLabel": "CreditsDisplay-module__fwgGJW__mergedCodeLabel",
  "readMoreToggle": "CreditsDisplay-module__fwgGJW__readMoreToggle",
  "redeemButtonWrapper": "CreditsDisplay-module__fwgGJW__redeemButtonWrapper",
  "tooltipBody": "CreditsDisplay-module__fwgGJW__tooltipBody",
});
